import React from 'react'

const ShippingTwo = () => {
    return (
        <section className="shipping mb-80" id="shipping">
            <div className="shipping-wrapper">
                <div className="container container-lg">
                    <div className="mb-40">
                        <h1 className="mb-16">Shipping &amp; Turnaround Information</h1>
                        <h3 className="mb-8">The Fast &amp; Reliable Panda Print Production Process</h3>
                        <ol className="mb-32">
                            <li>
                                Order Placed: The process starts the moment you finish your order.
                            </li>
                            <li>
                                Individually Reviewed: Your design and order are double-checked by our pre-flight team to ensure accuracy.
                            </li>
                            <li>
                                Printed, Cut &amp; Finalized:Signs are printed, cut, sewn, and accessories are added as needed.
                            </li>
                            <li>
                                Packaged &amp; Shipped:Your order is carefully packaged and shipped via our trusted carriers.
                            </li>
                        </ol>
                    </div>
                    <div className="mb-32">
                        <h3 className="mb-8">Standard Turn Times</h3>
                        <p>
                            Most orders are produced within one business day if placed before 9pm EST, Monday through Friday. Some products may require more time due to size or quantity. Delivery dates and shipping costs can be checked using our Price Calculator during checkout.
                        </p>
                    </div>
                    <div className="mb-32">
                        <h3 className="mb-8">Shipping Methods</h3>
                        <ul>
                            <li>Free ground shipping on orders over $99 (restrictions apply).</li>
                            <li>Expedited options: Overnight, Priority Overnight, 2 Day, Saturday delivery, and Ground shipping.</li>
                            <li>Multi-location shipping supported.</li>
                            <li>
                                Oversized orders, rigid large signs, or large-quantity orders may require freight shipping. Freight shipments do not qualify for free shipping, and will be quoted separately.
                            </li>
                        </ul>
                    </div>
                    <div className="mb-32">
                        <h3 className="mb-8">Order Tracking &amp; Delivery</h3>
                        <ul>
                            <li>
                                Track your order status in your account dashboard once shipped. Tracking numbers are provided by email.
                            </li>
                            <li>
                                Standard shipping delivers by 5pm (business) or 8pm (residential). Priority overnight arrives by noon local time in most areas.
                            </li>
                            <li>
                                Delivery dates account for both production and shipping time, and can be checked before placing an order.
                            </li>
                            <li>
                                In-store pickup available—wait for pickup confirmation email before arrival.
                            </li>
                            <li>
                                Saturday delivery is available for an additional fee where offered by carriers.
                            </li>
                        </ul>
                    </div>
                    <div className="mb-32">
                        <h3 className="mb-8">FAQs</h3>
                        <ul>
                            <li>
                                <b>Do you offer free shipping?</b></li> <p>Orders over $99 shipped within the contiguous US (excluding oversized/freight) qualify for free ground shipping.</p>
                            <li>
                                <b>How do I track my order?</b></li> <p>Track any order from your account page. Tracking numbers are sent via email and can take up to 24 hours to become active.</p>
                            
                            <li>
                                <b>Can I ship to multiple locations?</b> </li><p>Yes, just use the multi-location shipping features in the checkout process.</p>
                            
                            <li>
                                <b>Do you ship internationally or to APO/FPO?</b></li> <p>Yes, request a custom quote for international and APO/FPO shipping at checkout.</p>
                            
                            <li>
                                <b>Can I make changes to my order after placing it?</b></li><p>Contact us immediately for any changes or cancellations; we cannot guarantee changes after production has started.</p> 
                        
                            <li>
                                <b>What if my order is lost or damaged?</b> </li><p>Contact our support team for help with any lost or damaged shipments, we will make it right!</p>
                            
                        </ul>
                    </div>
                    <div className="mb-40">
                        <h3 className="mb-8">Need Help?</h3>
                        <p>
                            Live chat, call us, or email <b>info@pandaprint.ca</b>. We’re here to help!
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ShippingTwo